import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Gift, Phone, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Confirmation() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const number = state?.subscriberNumber;
  const eligible = state?.launchOfferEligible;

  return (
    <div className="min-h-screen bg-[#FDFBF7] bg-grain flex items-center justify-center px-5 py-16">
      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        data-testid="confirmation-screen"
        className="max-w-lg w-full bg-white rounded-2xl border border-[#E5DEC9] shadow-lg p-8 text-center"
      >
        <div className="mx-auto w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center">
          <CheckCircle2 className="w-9 h-9 text-emerald-700" />
        </div>
        <h1 className="font-serif text-3xl font-bold text-[#581825] mt-6">Merci !</h1>
        <p className="text-[#1A1818] mt-4 leading-relaxed">
          Votre demande d'abonnement à la BOX VIN a bien été enregistrée. La Cave Christophe
          va vous transmettre les informations nécessaires pour le règlement.
        </p>

        {number && (
          <p className="mt-4 text-sm text-[#6E675F]">
            Votre numéro d'abonné : <span className="font-bold text-[#581825]">#{number}</span>
          </p>
        )}
        {eligible && (
          <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#C5A059]/20 text-[#581825] px-4 py-2 text-sm font-semibold">
            <Gift className="w-4 h-4" /> Vous faites partie des 40 premiers : bouteille surprise offerte !
          </div>
        )}

        <div className="mt-8 space-y-2 text-sm text-[#6E675F]">
          <p className="flex items-center justify-center gap-2"><Phone className="w-4 h-4 text-[#581825]" /> 06 07 15 59 70</p>
          <p className="flex items-center justify-center gap-2"><Mail className="w-4 h-4 text-[#581825]" /> caves.christophe@wanadoo.fr</p>
        </div>

        <Button onClick={() => navigate("/")} className="mt-8 bg-[#581825] hover:bg-[#42101A] text-[#FDFBF7] rounded-full px-8">
          Retour à l'accueil
        </Button>
      </motion.div>
    </div>
  );
}
